import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { states } from '@/constants/lifecycle';

const isValid = (status, config) => status === states.NONE && config.valid();

export const fetchConfig = (dependencies = [], valid = () => true) => ({
  dependencies,
  valid,
});

const useFetch = (fetch, status, config = fetchConfig()) => {
  useEffect(() => {
    if (isValid(status, config)) {
      fetch();
    }
  }, config.dependencies);
};

const useFetchByCategory = (fetch, category, status, config = fetchConfig()) => {
  useEffect(() => {
    if (isValid(status, config)) {
      fetch(category);
    }
  }, config.dependencies);
};

const useFetchByCode = (fetch, category, code, status, config = fetchConfig()) => {
  useEffect(() => {
    if (isValid(status, config)) {
      fetch(category, code);
    }
  }, config.dependencies);
};

const useFetchDispatch = (type, status, props = {}, config = fetchConfig()) => {
  const handler = useDispatch();

  useEffect(() => {
    if (isValid(status, config)) {
      handler({ type, ...props });
    }
  }, config.dependencies);
};

export default {
  useFetch,
  useFetchByCategory,
  useFetchByCode,
  useFetchDispatch,
};
